import { Clock, Euro, Flame, Hammer } from "lucide-react";
import { Reveal } from "./Motion";
import { useT } from "@/i18n";

// Indicative Italian market ranges (new detached house), shown with a disclaimer.
const ROWS = [
  ["time", Clock, "Tempi complessivi", "4 – 6 mesi", "12 – 18 mesi", "Dal permesso di costruire alla consegna delle chiavi."],
  ["mount", Hammer, "Montaggio della struttura", "1 – 3 settimane", "3 – 6 mesi", "Elementi prodotti in stabilimento e montati a secco in cantiere."],
  ["cost", Euro, "Costo chiavi in mano", "1.500 – 2.300 €/m²", "1.400 – 2.200 €/m²", "Costi simili; con il legno i tempi brevi riducono affitti, interessi e imprevisti di cantiere."],
  ["energy", Flame, "Consumi per riscaldamento", "15 – 30 kWh/m² anno", "50 – 100 kWh/m² anno", "Confronto tra una casa in legno ad alta efficienza e una muratura tradizionale."],
];

const Row = ({ r, t }) => {
  const [id, Icon, label, wood, brick, note] = r;
  return (
    <div className="grid gap-4 border-t border-[#121110]/15 py-6 sm:grid-cols-12 sm:items-center" data-testid={`compare-row-${id}`}>
      <div className="flex items-start gap-3 sm:col-span-4">
        <Icon className="mt-1 h-5 w-5 shrink-0 text-[#C26D38]" />
        <div>
          <p className="font-display text-lg font-bold">{t(`cmp.${id}`, label)}</p>
          <p className="mt-1 text-sm text-[#5A544C]">{t(`cmp.${id}N`, note)}</p>
        </div>
      </div>
      <p className="bg-[#C26D38] px-4 py-3 font-display text-lg font-bold text-[#FFF8F0] sm:col-span-4" data-testid={`compare-wood-${id}`}>
        <span className="block font-mono text-xs font-normal uppercase tracking-[0.2em] text-[#FFE6D2] sm:hidden">{t("cmp.wood", "Casa in legno")}</span>{t(`cmp.${id}W`, wood)}
      </p>
      <p className="bg-[#E4DED3] px-4 py-3 font-display text-lg font-bold text-[#3D3833] sm:col-span-4" data-testid={`compare-brick-${id}`}>
        <span className="block font-mono text-xs font-normal uppercase tracking-[0.2em] text-[#5A544C] sm:hidden">{t("cmp.brick", "Casa in muratura")}</span>{t(`cmp.${id}B`, brick)}
      </p>
    </div>
  );
};

export const HouseCompare = () => {
  const t = useT();
  return (
    <Reveal className="mx-auto mt-24 max-w-[1500px]" data-testid="house-compare">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C26D38]">{t("cmp.label", "Legno o muratura?")}</p>
      <h3 className="mt-4 max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl">{t("cmp.h", "Tempi, costi e consumi a confronto.")}</h3>
      <div className="mt-10 hidden font-mono text-xs uppercase tracking-[0.2em] sm:grid sm:grid-cols-12">
        <span className="sm:col-span-4" />
        <span className="px-4 text-[#C26D38] sm:col-span-4">{t("cmp.wood", "Casa in legno")}</span>
        <span className="px-4 text-[#5A544C] sm:col-span-4">{t("cmp.brick", "Casa in muratura")}</span>
      </div>
      <div className="mt-4 border-b border-[#121110]/15">{ROWS.map((r) => <Row key={r[0]} r={r} t={t} />)}</div>
      <p className="mt-4 max-w-3xl text-xs leading-relaxed text-[#5A544C]" data-testid="compare-note">{t("cmp.note", "Valori indicativi medi di settore per una casa unifamiliare di nuova costruzione in Italia; variano con progetto, finiture, zona climatica e località. Per i numeri del tuo progetto chiedi un preventivo.")}</p>
    </Reveal>
  );
};
